import {BrandingCountries} from '../../common/types'
import {useFeaturesState, DataScope, FeatureConstraint} from '../../Organisms/Features'

interface ShowTermsForOrderIntakeResult {
  enabled: boolean
  countryId: string
  url: string
}

interface ExtendedDataScope extends DataScope {
  url?: string
}

export const useShowTermsForOrderIntake = (country?: string): ShowTermsForOrderIntakeResult => {
  const {normalized} = useFeaturesState()

  const featureFlag = normalized['showTermsForOrderIntake']

  if (!featureFlag || !country) {
    return {enabled: false, countryId: '', url: ''}
  }

  const constraint = featureFlag.constraints?.find((c: FeatureConstraint) => {
    if (!c.enabled) return false

    let dataScope: ExtendedDataScope
    if (typeof c.dataScope === 'string') {
      dataScope = JSON.parse(c.dataScope) as ExtendedDataScope
    } else {
      dataScope = c.dataScope as ExtendedDataScope
    }

    // Handle both single country and array of countries
    if (Array.isArray(dataScope.countryId)) {
      return dataScope.countryId.includes(country as BrandingCountries)
    }

    return dataScope.countryId === country
  })

  if (constraint) {
    let dataScope: ExtendedDataScope
    if (typeof constraint.dataScope === 'string') {
      dataScope = JSON.parse(constraint.dataScope) as ExtendedDataScope
    } else {
      dataScope = constraint.dataScope as ExtendedDataScope
    }

    // Extract the country ID as string
    const extractedCountryId = Array.isArray(dataScope.countryId)
      ? dataScope.countryId.find((id) => id === country) || ''
      : dataScope.countryId || ''

    return {
      enabled: constraint.enabled,
      countryId: extractedCountryId,
      url: dataScope.url || ''
    }
  }

  return {enabled: false, countryId: '', url: ''}
}
